var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading && !_vm.loaded)?_c('div',{staticClass:"Loads acea-row row-center-wrapper",staticStyle:{"margin-top":".2rem"}},[(_vm.loading)?_c('div',[_c('div',{staticClass:"iconfont icon-jiazai loading acea-row row-center-wrapper"}),_vm._v("\n      正在加载中\n    ")]):_c('div',[_vm._v("\n      上拉加载更多\n    ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }